import * as Yup from 'yup';

export const FirmPortfolioCreateUpdateItemFormValidationSchema = Yup.object().shape(
  {
    AssignedFirmID: Yup.object()
      .nullable()
      .test(
        'stringLength',
        'You have exceeded the maximum number of 100 characters',
        value => !(value && value.__isNew__ && value.value.length > 100)
      )
      .required('This field is required'),

    Transaction: Yup.string()
      .nullable()
      .max(255, 'You have exceeded the maximum number of 255 characters'),

    Description: Yup.string()
      .nullable()
      .max(1000, 'You have exceeded the maximum number of 1000 characters'),
  }
);
